import { INTEGRATIONS } from "constants/action-types";

export const createBrandSchemaMap = () => ({
    payload: {},
    type: INTEGRATIONS.BRAND_SCHEMA_MAP.CREATE.START,
});

export const updateBrandSchemaMap = (brandSchemaMap) => ({
    payload: brandSchemaMap,
    type: INTEGRATIONS.BRAND_SCHEMA_MAP.UPDATE.START,
});

export const getBrandSchemaMap = (brandId: string) => ({
    payload: brandId,
    type: INTEGRATIONS.BRAND_SCHEMA_MAP.FETCH.START,
});

export const getNuOrderMasterSchema = () => ({
    payload: {},
    type: INTEGRATIONS.MASTER_SCHEMA.FETCH.START,
});

export const resetBrandSchemaState = () => ({
    payload: {},
    type: INTEGRATIONS.BRAND_SCHEMA_MAP.RESET,
});
